import { MenuList } from '../../../../../types/menu';
import { UserAuth } from '../../../../../types/user';
import { ThemeSystem } from '../../../../../views/my-learning/dashboard/themeColor';
import Sidebar from './Sidebar';

export default Sidebar;

export interface SidebarProps {
  menuList: MenuList[];
  user: UserAuth;
  theme?: ThemeSystem;
}
